import { connect } from "react-redux";
import { Store } from "Store/index";
import { Hero, HeroProps } from "Views/presentational/hero";

type StateProps = Pick<HeroProps, "screenSize">;
type queryMatches = Store["browser"]["matching_media_queries"];

function getScreenSize(queries: queryMatches): StateProps["screenSize"] {
  const matches = queries.filter(query => query.id === "720");
  return matches.length > 0 ? "LARGE" : "SMALL";
}

function mapStateToProps(state: Store): StateProps {
  return {
    screenSize: getScreenSize(state.browser.matching_media_queries)
  };
}

const hero_hoc = connect(mapStateToProps, {})(Hero);

export { hero_hoc as HeroHOC };
